import { handleActions } from 'redux-actions';

import { deepFreeze } from '@mw/helpers';

import { checkIsIframe } from '~/helpers';

import {
  setBrowserId,
  setEchoAgent,
  setEchoChannel,
  setGlobal,
  setIsSocketConnected,
  setIsSubApp,
} from '~/actions/global';

const initialState = deepFreeze({
  echoAgentId: null,
  echoChannelId: null,
  isSocketConnected: false,
  browserId: null,
  isSubApp: checkIsIframe(),

  curChatChannelType: null,
  curChatProviderType: null,
  curChatAgentID: null,
  curChatChannelID: null,
  lastMessageId: null,
});

export const global = handleActions(
  {
    [setGlobal]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [setIsSocketConnected]: (state, { payload }) => ({
      ...state,
      isSocketConnected: payload,
    }),
    [setEchoAgent]: (state, { payload: echoAgentId }) => ({
      ...state,
      echoAgentId,
    }),
    [setEchoChannel]: (state, { payload: echoChannelId }) => ({
      ...state,
      echoChannelId,
    }),
    [setBrowserId]: (state, { payload }) => ({
      ...state,
      browserId: payload,
    }),
    [setIsSubApp]: (state, { payload }) => ({
      ...state,
      isSubApp: payload,
    }),
  },
  initialState
);
